export type DiagnosticsChartType =
  | 'connection'
  | 'current'
  | 'currentOffered'
  | 'power'
  | 'voltage'
  | 'temperature'
  | 'event'
  | 'amber';

export const diagnosticsChartIds: Record<DiagnosticsChartType, string> = {
  connection: 'connectionChart',
  current: 'currentChart',
  currentOffered: 'currentOfferedChart',
  power: 'powerChart',
  voltage: 'voltageChart',
  temperature: 'temperatureChart',
  event: 'eventChart',
  amber: 'amberChart',
};

export const CHART_DATE_FORMAT = 'HH:mm:ss DD/MM/YY';
